import $ from 'jquery';

$(function () {
    $('.filter-form').on('change', 'select', function () {
        const $this = $(this);
        const $form = $this.parents('form');
        doSearch($form);
    });
    $('.filter-form .clear').on('click', function (evt) {
        evt.preventDefault();
        const $this = $(this);
        const $form = $this.parents('form');
        $form[0].reset();
        doSearch($form);
    });

    function doSearch($form) {
        const $results = $('#' + $form.data('results-holder-id'));
        const $pagerContainer = $('#' + $form.data('pager-container-id'));

        //TODO: add transitions  / animations
        $.post($form.prop('action'), $form.serialize(), function (data) {
            $results.empty();
            $('.no-results').addClass('hide');
            if (data.HtmlResults?.length) {
                $results.append(data.HtmlResults);
            } else {
                $('.no-results').removeClass('hide');
            }
            $pagerContainer.empty();
            $pagerContainer.append(data.PagerResults);
        });
    }
});